import ApplicationController from '../application_controller'

class EventTypeSelectorController extends ApplicationController {
  connect () {
    $(this.element).select2({
      formatSelection: (data, container) => {
        container.prevObject[0].style.backgroundColor = data.element[0].style.backgroundColor

        return data.text
      },
      escapeMarkup: (m) => {
        return m
      }
    })
  }
}

export default EventTypeSelectorController
